export enum ExamAnalyticsEnum {
  VIEW_PAGE_SEO_EXAMS_INDEX = '[PAC WEB] Índice de Exames - Página visualizada',
  CLICK_TITLE_EXAM_IN_CARD = '[PAC WEB] Índice de Exames - Expandiu exame',
  CLICK_TITLE_STATE_IN_EXAM_CARD = '[PAC WEB] Índice de Exames - Expandiu estado (UF)',
  CLICK_EXAM_BY_CITY = '[PAC WEB] Índice de Exames - Clicou em exame por cidade',
  CLICK_SEE_EVERY_SEO_EXAM_BUTTON = '[PAC WEB] Índice de Exames - Clicou em "Ver todos"',
  CLICK_SEE_EVERY_EXAM_BY_EXAM_CARD = '[PAC WEB] Índice de Exames - Clicou em "Ver mais" por exame',
  CLICK_SEE_EVERY_EXAM_BY_UF_BY_EXAM_CARD = '[PAC WEB] Índice de Exames - Clicou em "Ver mais" por exame e UF',
  CLICK_CTA_SCHEDULE_EXAM_BY_WEB_BUTTON = '[PAC WEB] Índice de Exames - Clicou em "Agendar pelo site"',
  CLICK_CTA_SCHEDULE_EXAM_BY_ASSISTED_PURCHASE_BUTTON = '[PAC WEB] Índice de Exames - Clicou em "Agendar com atendente"',
}
